import { TELEGRAM_URL, LANGS } from "../i18n";
import { trackCTA } from "../lib/track";

export const Navbar = ({ t, lang, setLang }) => (
  <nav
    data-testid="navbar"
    className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-black/60 backdrop-blur-2xl"
  >
    <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
      <a href="#top" data-testid="nav-logo" className="flex items-center gap-2.5">
        <img src="/gta-logo-icon.jpeg" alt="GTA logo" className="h-9 w-9 rounded-lg border border-[#EAB308]/40 object-cover" />
        <span className="font-['Outfit'] text-lg font-bold tracking-tight">
          GTA <span className="hidden font-normal text-gray-400 sm:inline">· Global Trading Academy</span>
        </span>
      </a>

      <div className="hidden items-center gap-8 text-sm text-gray-300 lg:flex">
        <a data-testid="nav-system-link" href="#system" className="transition-colors duration-200 hover:text-[#EAB308]">{t.nav.system}</a>
        <a data-testid="nav-why-link" href="#why" className="transition-colors duration-200 hover:text-[#EAB308]">{t.nav.why}</a>
        <a data-testid="nav-results-link" href="#results" className="transition-colors duration-200 hover:text-[#EAB308]">{t.nav.results}</a>
      </div>

      <div className="flex items-center gap-3">
        <div
          data-testid="language-toggle"
          className="flex items-center rounded-full border border-white/10 bg-white/5 p-1"
        >
          {LANGS.map((l) => (
            <button
              key={l.code}
              data-testid={`language-toggle-${l.code}`}
              onClick={() => setLang(l.code)}
              className={`rounded-full px-3 py-1.5 text-xs font-semibold uppercase tracking-wider transition-[background-color,color] duration-300 ${
                lang === l.code ? "bg-[#EAB308] text-[#0B0E11]" : "text-gray-400 hover:text-white"
              }`}
            >
              {l.label}
            </button>
          ))}
        </div>
        <a
          data-testid="nav-join-button"
          href={TELEGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackCTA("navbar_community")}
          className="rounded-full bg-[#EAB308] px-5 py-2.5 text-sm font-bold text-[#0B0E11] transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-[#FACC15]"
        >
          {t.nav.joinCommunity}
        </a>
      </div>
    </div>
  </nav>
);
